// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const registeel: PokeData = {
  "id": 379,
  "name": "registeel",
  "height": 19,
  "weight": 2050,
  "base_experience": 261,
  "types": [
    PokeType.STEEL
  ],
  "api_moves": [
    "stomp",
    "hyper-beam",
    "amnesia",
    "explosion",
    "curse",
    "zap-cannon",
    "lock-on",
    "metal-claw",
    "ancient-power",
    "superpower",
    "iron-defense",
    "hammer-arm",
    "flash-cannon",
    "iron-head",
    "charge-beam",
    "heavy-slam",
    "bulldoze"
  ],
  "moves": [
    "curse",
    "zap-cannon",
    "metal-claw",
    "ancient-power",
    "superpower",
    "magnet-pull",
    "scrap-throw",
    "metal-sound",
    "metal-burst",
    "earthquake",
    "magnet-bomb",
    "iron-defense",
    "behemoth-bash"
  ],
  "evolution_chain": {
    "id": 195,
    "item": null,
    "species": [
      {
        "name": "registeel",
        "order": 409,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 192,
    "speed": 83,
    "ability_power": 125
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
